import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

const convertToNewRequest = (request: { allow: boolean }) => {
  return {
    blockSignerAccess: !request.allow,
  };
};

/**
 * 문서 차단 여부 설정하는 API  호출
 *
 * @deprecated Endpoint request and path are modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#a1896b90617f4d0385876823dbd7b122
 */
// eslint-disable-next-line import/prefer-default-export
export function setDocumentAccessable({
  workspaceId,
  documentId,
  isAccessable,
}: {
  workspaceId: string;
  documentId: string;
  isAccessable: boolean;
}) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/signer-access`),
    method: 'PUT',
    data: convertToNewRequest({
      allow: isAccessable,
    }),
    credentials: true,
  });
}
